import axios from 'axios'

export async function getSubscriptionStatus(publicId: string) {
  const { data: { subscribed } } = await axios.get(`/subscribers/topic/${publicId}`)
  return subscribed
}

export async function subscribeTopic (publicId: string) {
  return await axios.post(`/subscribers/topic/${publicId}`)
}

export async function unsubscribeTopic (publicId: string) {
  return await axios.delete(`/subscribers/topic/${publicId}`)
}
